import React from 'react';
import './LoadingPage.css';

function LoadingPage() {
  return (
    <div className='loading-page'>
      <div className='loader'>
      </div>
      <p>جاري تحميل البيانات...</p>
    </div>
  )
}

export default LoadingPage;